import { render, staticRenderFns } from "./InstructionCard.vue?vue&type=template&id=aaedfdc4"
import script from "./InstructionCard.vue?vue&type=script&lang=js"
export * from "./InstructionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports